var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E64B38;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,0C16.2,0,16,0.2,16,0.5v2.8h-3.4V3.1c0-0.8-0.7-1.5-1.5-1.5H1.5C0.7,1.7,0,2.3,0,3.1v1.4 C0,5.3,0.7,6,1.5,6h9.6c0.8,0,1.5-0.7,1.5-1.5V4.3H16v4.5h-3.4V8.6c0-0.8-0.7-1.5-1.5-1.5H1.5C0.7,7.2,0,7.8,0,8.6V10 c0,0.8,0.7,1.5,1.5,1.5h9.6c0.8,0,1.5-0.7,1.5-1.5V9.8H16v3.5c0,0.6-0.5,1-1,1h-2.4v-0.2c0-0.8-0.7-1.5-1.5-1.5H1.5 c-0.8,0-1.5,0.7-1.5,1.5v1.4C0,16.3,0.7,17,1.5,17h9.6c0.8,0,1.5-0.7,1.5-1.5v-0.2H15c1.1,0,2-0.9,2-2V0.5C17,0.2,16.8,0,16.5,0z  M11.6,4.5c0,0.2-0.2,0.4-0.4,0.4H1.5C1.2,5,1,4.8,1,4.5V3.1c0-0.2,0.2-0.4,0.4-0.4h9.6c0.2,0,0.4,0.2,0.4,0.4V4.5z M11.6,10 c0,0.2-0.2,0.4-0.4,0.4H1.5C1.2,10.5,1,10.3,1,10V8.6c0-0.2,0.2-0.4,0.4-0.4h9.6c0.2,0,0.4,0.2,0.4,0.4V10z M11.6,15.5 c0,0.2-0.2,0.4-0.4,0.4H1.5C1.2,16,1,15.8,1,15.5v-1.4c0-0.2,0.2-0.4,0.4-0.4h9.6c0.2,0,0.4,0.2,0.4,0.4V15.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulesIcon);
export default __webpack_public_path__ + "static/media/rules-icon.20239327264d853903745a6ac3c9f5bb.svg";
export { ForwardRef as ReactComponent };